var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmszukunftshelden2023PlatzhaltergrafikRgb = function SvgEmszukunftshelden2023PlatzhaltergrafikRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 600,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 600",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "bl\\xE4tter_gro\\xDF",
    "data-name": "bl\\xE4tter gro\\xDF",
    x: 0,
    y: 0,
    width: 125.05,
    height: 195.33,
    patternTransform: "translate(1111.08 -736.73)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 125.05 195.33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 125.05,
    height: 195.33,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86,186.6l-.81-1.09c-1.64-2.22-2.34-4.98-1.95-7.72,2.45-17.15,13.44-59.47,62.41-64.43,16.16-1.64,26.46-7.24,33.31-18.15,1.09-1.73,3.66-3.07,5.71-2.96h0c2.05.47,3.49,2.21,3.54,4.28.07,2.14,1.27,52.84-27.69,78.97-3.9,3.51-8.15,6.41-12.75,8.69-10.9,5.4-22.12,7.51-38.18,7.08,0,0-15.12-1-17.57-1.6s-4.61-1.16-6.03-3.07ZM75.06,168.72c17.22-15.54,22.38-42.22,23.9-58.27-10.23,8.89-22.48,11.27-31.71,12.2-39.91,4.04-50.47,36.43-53.29,52.86,5.26-3.47,9.88-6.65,13.47-9.36,1.64-1.23,5.01-3.63,9.22-6.58l4.4-22.54c.5-2.55,2.99-4.25,5.57-3.84,2.57.43,4.27,2.82,3.77,5.36l-2.58,13.24c.63-.44,1.26-.88,1.89-1.32,9.95-6.92,20.08-13.97,23.5-16.56,2.11-1.61,5.09-1.26,6.66.77,1.58,2.02,1.14,4.95-.97,6.55-3.46,2.62-13.74,9.78-23.81,16.79-.45.31-.9.63-1.35.94l14.97,1.3c2.62.23,4.48,2.49,4.19,5.05-.19,1.66-1.24,3.04-2.67,3.74-.79.39-1.69.57-2.6.49l-25.86-2.25c-3.95,2.77-7.09,5-8.65,6.18-2.77,2.1-6.22,4.49-9.95,7.01l8.13.8c14.08,1.42,32.79-2.65,43.77-12.56h0Z",
    style: {
      fill: "#939393",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.19,8.72l.81,1.09c1.64,2.22,2.34,4.98,1.95,7.72-2.45,17.15-13.44,59.47-62.41,64.43-16.16,1.64-26.46,7.24-33.31,18.15-1.09,1.73-3.66,3.07-5.71,2.96h0c-2.05-.47-3.49-2.21-3.54-4.28-.07-2.14-1.27-52.84,27.69-78.97,3.9-3.51,8.15-6.41,12.75-8.69,10.9-5.4,22.12-7.51,38.18-7.08,0,0,15.12,1,17.57,1.6s4.61,1.16,6.03,3.07ZM49.99,26.61c-17.22,15.54-22.38,42.22-23.9,58.27,10.23-8.89,22.48-11.27,31.71-12.2,39.91-4.04,50.47-36.43,53.29-52.86-5.26,3.47-9.88,6.65-13.47,9.36-1.64,1.23-5.01,3.63-9.22,6.58l-4.4,22.54c-.5,2.55-2.99,4.25-5.57,3.84-2.57-.43-4.27-2.82-3.77-5.36l2.58-13.24c-.63.44-1.26.88-1.89,1.32-9.95,6.92-20.08,13.97-23.5,16.56-2.11,1.61-5.09,1.26-6.66-.77-1.58-2.02-1.14-4.95.97-6.55,3.46-2.62,13.74-9.78,23.81-16.79.45-.31.9-.63,1.35-.94l-14.97-1.3c-2.62-.23-4.48-2.49-4.19-5.05.19-1.66,1.24-3.04,2.67-3.74.79-.39,1.69-.57,2.6-.49l25.86,2.25c3.95-2.77,7.09-5,8.65-6.18,2.77-2.1,6.22-4.49,9.95-7.01l-8.13-.8c-14.08-1.42-32.79,2.65-43.77,12.56h0Z",
    style: {
      fill: "#939393",
      strokeWidth: 0
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    y: 0.35,
    width: 800,
    height: 600,
    style: {
      fill: "#ececec",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 800,
    height: 600,
    style: {
      fill: "url(#bl\xE4tter_gro\xDF)",
      opacity: 0.7,
      strokeWidth: 0
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmszukunftshelden2023PlatzhaltergrafikRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emszukunftshelden2023-platzhaltergrafik-rgb.88efe862445ecca3e079f75afef8e31e.svg";